export default {"src":"/_next/static/media/git.21d80414.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};